<mat-card class="cardWithShadow theme-card">
  <mat-card-content class="b-t-1">
    <p>This step highlights the necessity of creating a new key when the current key has been shared, distributed, or
      potentially exposed. This step involves replacing the existing key with the newly generated one. Updating the key
      ensures that systems, applications, or services are configured to use the latest secure key.</p>
    <h3 class="f-w-500">API key</h3>
    <div class="api-key-flex gap-1">
      <div class="api-key">
        <input type="" class="form-control" disabled readonly="true" [value]="Key?.api_key">
        @if(token){<img class="check-icon" src="assets/images/svgs/Checkmark.png" alt="" matTooltip="API Active">}
      </div>
      <div class="d-flex gap-1">
        <button [disabled]="!Key" title="Copy key" class="copy" (click)="copy(Key?.api_key)"><i-tabler class="routeIcon"
            name="copy" matListItemIcon></i-tabler></button>
        <button [disabled]="!Key" mat-flat-button color="primary" class="w-50" (click)="openDiilog('api_key')">
          Refresh
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-content class="b-t-1">
    <h3 class="f-w-500">API Token</h3>
    <div class="api-key-flex gap-1">
      <div class="api-key">
        <input type="" class="form-control" disabled readonly="true" [value]="token">
        @if(token){<img class="check-icon" src="assets/images/svgs/Checkmark.png" alt=""  matTooltip="Token Active">}
      </div>
      <div class="d-flex gap-1">
        <button [disabled]="!token" title="Copy token" class="copy" (click)="copy(token)"><i-tabler class="routeIcon"
            name="copy" matListItemIcon></i-tabler></button>
        <button mat-flat-button color="primary" class="w-50" (click)="openDiilog('token')">
          @if(token){
            Refresh
          } @else {
            Generate
          }
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>